export default {
  SET_NEWS: (state, data) => {
    state.news = data;
  },
  SET_SINGLE_NEWS: (state, data) => {
    state.single_news = data;
  },
  SET_ACTIVE_NEWS: (state, data) => {
    state.active_news = data;
  },
};
